import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import SafeJsonLd from '@/components/SafeJsonLd';
import { useLanguage } from '@/contexts/LanguageContext';

interface ServiceBreadcrumbProps {
  /** Final crumb label (the current page) */
  label: string;
  /** Canonical URL of current page (used in BreadcrumbList) */
  url: string;
}

const ServiceBreadcrumb: React.FC<ServiceBreadcrumbProps> = ({ label, url }) => {
  const { language } = useLanguage();
  const isPT = language === 'pt';

  const items = [
    { name: isPT ? 'Início' : 'Home',                     url: 'https://spawncore.com/' },
    { name: isPT ? 'Serviços' : 'Services',               url: 'https://spawncore.com/#services' },
    { name: label,                                         url },
  ];

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <>
      <SafeJsonLd data={schema} />
      <nav
        aria-label="Breadcrumb"
        className="mx-auto max-w-7xl px-6 lg:px-8 pt-6"
      >
        <ol className="flex items-center gap-2 font-mono-tag text-[11px] uppercase tracking-[0.24em] text-muted-foreground">
          <li>
            <Link to="/" className="hover:text-foreground smooth-transition">
              {items[0].name}
            </Link>
          </li>
          <ChevronRight className="h-3 w-3 opacity-50" />
          <li>
            <Link to="/#services" className="hover:text-foreground smooth-transition">
              {items[1].name}
            </Link>
          </li>
          <ChevronRight className="h-3 w-3 opacity-50" />
          <li className="text-foreground">{items[2].name}</li>
        </ol>
      </nav>
    </>
  );
};

export default ServiceBreadcrumb;
